import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReports = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.1667 3C14.1779 3 15 3.78477 15 4.75V15.25C15 16.2152 14.1779 17 13.1667 17H5.83333C4.82214 17 4 16.2152 4 15.25V7.375H7.66667C8.1737 7.375 8.58333 6.98398 8.58333 6.5V3H13.1667ZM7.66667 3V6.5H4L7.66667 3ZM8.8125 9.78125V14.5938C8.8125 14.9574 9.11901 15.25 9.5 15.25C9.88099 15.25 10.1875 14.9574 10.1875 14.5938V9.78125C10.1875 9.41758 9.88099 9.125 9.5 9.125C9.11901 9.125 8.8125 9.41758 8.8125 9.78125ZM6.29167 11.5312V14.5938C6.29167 14.9574 6.59818 15.25 6.97917 15.25C7.36016 15.25 7.66667 14.9574 7.66667 14.5938V11.5312C7.66667 11.1676 7.36016 10.875 6.97917 10.875C6.59818 10.875 6.29167 11.1676 6.29167 11.5312ZM11.3333 13.2812V14.5938C11.3333 14.9574 11.6398 15.25 12.0208 15.25C12.4018 15.25 12.7083 14.9574 12.7083 14.5938V13.2812C12.7083 12.9176 12.4018 12.625 12.0208 12.625C11.6398 12.625 11.3333 12.9176 11.3333 13.2812Z",
		fill: "#0D2976"
	})
});
export default SvgReports;
